import { resolveBrandAssetSrc } from '@/features/shared/brand/branding-core'
import { useBranding } from '@/features/shared/brand/branding-hooks'

export function MobileAuthBrandHeader({ title }: { title: string }) {
  const {
    settings: { description, hasCustomTitle, logo, title: brandTitle },
  } = useBranding()
  const displayedTitle = hasCustomTitle ? brandTitle : title
  const subtitle = description.trim()

  return (
    <header className="flex flex-col items-center">
      <div className="flex size-12 items-center justify-center">
        <img alt="" className="size-12" src={resolveBrandAssetSrc(logo)} />
      </div>
      <h1 className="mt-[18px] text-center text-[22px] font-semibold leading-[1.2] text-[var(--color-text)]">
        {displayedTitle}
      </h1>
      {subtitle ? (
        <p className="mt-2.5 text-center text-[13px] leading-5 text-[var(--color-text-muted)]">
          {subtitle}
        </p>
      ) : null}
    </header>
  )
}
